{
  let slideMain = document.querySelector("slide-show");
  if (slideMain) {
    let sliderItems = document.querySelectorAll("slide-show-item");

    sliderItems.forEach(item => {
      item.addEventListener("click", (e) => {
        // e.preventDefault();
        let linkElement = item.querySelector(".slideshow__slide-inner");
        let outboundUrl = linkElement ? linkElement.getAttribute("href") : null;
        let position  = item.dataset.position
        if(outboundUrl.includes("/products/")){
          const name = linkElement.getAttribute('data-product-title') || null;
          const price = linkElement.getAttribute('data-product-price') || null;
          const sku = linkElement.getAttribute('data-product-sku') || null;
          const upc = linkElement.getAttribute('data-product-upc') || null;
          const variant = linkElement.getAttribute('data-product-variant') || null
          
          tagular("ProductClicked", {
            actionOutcome: "INTERNALLINK",
            correlationId: null,
            viewCorrelationId: null,
            listId: null,
            outboundUrl: outboundUrl,
            product: {
              brand: "SHOP",
              category: null,
              coupon: null,
              formatSubtype: null,
              formatType: variant,
              location: `Shop Hero`,
              name: name,
              pageId: null,
              position: parseInt(position),
              price: parseFloat(price),
              productId: null,
              quantity: 1,
              sku: sku,
              subscription: {
                frequency: null
              },
              text: "Shop Now",
              upc: upc,
              variant: variant,
              positionEngine: null
            }
          });
        } else {
          tagular("ElementClicked", {
            actionOutcome: "INTERNALLINK",
            outboundUrl: outboundUrl,
            webElement: {
              elementType: "Banner",
              htmlId: null,
              location: "Hero",
              name: "Hero Shop Now",
              position: position,
              text: null,
              variant: null
            }
          });
        }
      });
    });
  }
}

// End  Hero banner carousel ElementClicked HMPG-01



// Start Best Collections by category ElementViewed HMPG-05
const viewedProducts = new Set();

const observer = new IntersectionObserver((entries, obs) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const item = entry.target;
      const link = item.querySelector(".gallery_item_button a");
      if (!link) return;

      const productId = link.dataset.productId || item.getAttribute("data-position");
      if (viewedProducts.has(productId)) return; // Skip if already viewed

      viewedProducts.add(productId);

      let position = item.getAttribute("data-position") || null;
      let rawName = item.querySelector(".gallery__item__heading")?.getAttribute("data-name") || null;

      // Clean rawName (avoid HTML injection issues)
      let tempDiv = document.createElement("div");
      tempDiv.innerHTML = rawName;
      let name = tempDiv.innerText.trim();

      let text = item.querySelector(".gallery_item_description")?.innerText.trim() || null;
      let outboundUrl = link.href || null;

      tagular("ElementViewed", {
        webElement: {
          elementType: "Link",
          htmlId: null,
          location: "Which Guidebook Is Right For Me",
          name: name,
          position: position,
          text: text,
          variant: null
        }
      });

      obs.unobserve(item); // Stop observing after first view
    }
  });
}, { threshold: 0.2 });

// Observe all gallery items
const bestCollection = document.querySelector(".js-product-comparison");
if (bestCollection) {
  const galleryItems = bestCollection.querySelectorAll("gallery-item");
  galleryItems.forEach(item => observer.observe(item));
}


// End Best Collections by category ElementViewed



// Start Best Collections by category ElementClicked
{
    let bestCollection = document.querySelector(".js-product-comparison");
  
    if (bestCollection) {
      let galleryItems = bestCollection.querySelectorAll("gallery-item");
  
      galleryItems.forEach(item => {
        item.addEventListener("click", (e) => {
          // e.preventDefault();
  
          let outboundUrl = item.querySelector(".gallery_item_button a")?.href || null;
          let position = item.getAttribute("data-position") || null;
          let textElement = item.querySelector(".gallery_item_description");
          let rawName = item.querySelector(".gallery__item__heading")?.getAttribute("data-name") || null;
          let tempDiv = document.createElement("div");
          tempDiv.innerHTML = rawName;
          let name = tempDiv.innerText.trim();
          let text = textElement ? textElement.innerText.trim() : null;
          tagular("ElementClicked", {
            actionOutcome: "INTERNALLINK",
            outboundUrl: outboundUrl,
            webElement: {
              elementType: "Link",
              htmlId: null,
              location: "Which Guidebook Is Right For Me",
              name: name,
              position: position,
              text: text,
              variant: null
            }
          });
        });
      });
    }
  }

// End Best Collections by category ElementClicked HMPG-05

//HMPG-04 ElementClicked --start
{
let bestCollection = document.querySelector(".js-gallery");

if (bestCollection) {
  let galleryItems = bestCollection.querySelectorAll("gallery-item");

  galleryItems.forEach(item => {
    item.addEventListener("click", (e) => {
      // e.preventDefault();

      let outboundUrl = item.querySelector("figure a")?.href || null;
      let position = item.getAttribute("data-position") || null;
      let textElement = item.querySelector(".gallery_item_description");
      let name = item.getAttribute("data-name");
      let text = textElement ? textElement.innerText.trim() : null;

      tagular("ElementClicked", {
        actionOutcome: "INTERNALLINK",
        outboundUrl: outboundUrl,
        webElement: {
          elementType: "Tile",
          htmlId: null,
          location: "Shop Best Collection",
          name: name,
          position: position,
          text: null,
          variant: null
        }
      });
    });
  });
}
}
//HMPG-04 ElementClicked --end



// Product tile in review banner HMPG-06 HMPG-07 --start
{
  const viewedProducts = new Set();

  const observer = new IntersectionObserver((entries, obs) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const tile = entry.target;
      const link = tile.querySelector('a[href]');
      if (!link) return;

      const productId = link.dataset.productId;
      if (viewedProducts.has(productId)) return;

      viewedProducts.add(productId);
      
      const productData = extractProductData(link, tile);
      let position = parseInt(link.getAttribute("data-product-position"));
      
      tagular("ProductViewed", {
        // actionOutcome: "INTERNALLINK",
        // correlationId: null,
        // viewCorrelationId: null,
        // listId: null,
        // outboundUrl: productData.outboundUrl,
        product: {
          brand: "SHOP",
          category: productData.category,
          coupon: null,
          formatSubtype: null,
          formatType: productData.format,
          location: `${productData.location}`,
          name: productData.name,
          pageId: null,
          position: position,
          price: parseFloat(productData.price),
          productId: productData.id,
          quantity: 1,
          sku: productData.sku,
          subscription: {
            frequency: null
          },
          text: null,
          upc: productData.upc,
          variant: productData.format,
          positionEngine: null
        }
      });

      obs.unobserve(tile);
    }
  });
}, { threshold: 0.5 });

  let viewElement = document.querySelectorAll('testimonial-product-item');
  if (viewElement.length > 0) {
    viewElement.forEach(element =>{
      observer.observe(element);
    })
  }

document.querySelectorAll('.tp_image a').forEach(button => {
  button.addEventListener('click', (e) => {
    // e.preventDefault();
    const tile = e.currentTarget.closest('testimonial-product-item');
    const link = tile.querySelector('a[href]');
    if (!link) return;
    
    const productData = extractProductData(link, tile);
    let position = e.currentTarget.getAttribute("data-product-position");
    tagular("ProductClicked", {
      actionOutcome: "INTERNALLINK",
      correlationId: null,
      viewCorrelationId: null,
      listId: null,
      outboundUrl: productData.outboundUrl,
      product: {
        brand: "SHOP",
        category: productData.category,
        coupon: null,
        formatSubtype: null,
        formatType: productData.format,
        location: `${productData.location}`,
        name: productData.name,
        pageId: null,
        position: parseInt(position),
        price: parseFloat(productData.price),
        productId: productData.id,
        quantity: 1,
        sku: productData.sku,
        subscription: {
          frequency: null
        },
        text: null,
        upc: productData.upc,
        variant: productData.format,
        positionEngine: null
      }
    });
  });
});

document.querySelectorAll('.tp_button a').forEach(button => {
  button.addEventListener('click', (e) => {
    // e.preventDefault();
    let buttonText = e.currentTarget.textContent;
    const tile = e.currentTarget.closest('testimonial-product-item');
    const link = tile.querySelector('a[href]');
    if (!link) return;
    
    const productData = extractProductData(link, tile);
    let position = e.currentTarget.getAttribute("data-product-position");
    tagular("ProductClicked", {
      actionOutcome: "INTERNALLINK",
      correlationId: null,
      viewCorrelationId: null,
      listId: null,
      outboundUrl: productData.outboundUrl,
      product: {
        brand: "SHOP",
        category: `${productData.location}`,
        coupon: null,
        formatSubtype: null,
        formatType: productData.format,
        location: `${productData.location}`,
        name: productData.name,
        pageId: null,
        position: parseInt(position),
        price: parseFloat(productData.price),
        productId: productData.id,
        quantity: 1,
        sku: productData.sku,
        subscription: {
          frequency: null
        },
        text: buttonText,
        upc: productData.upc,
        variant: productData.format,
        positionEngine: null
      }
    });
  });
});

function extractProductData(link, tile) {
  const allVisibleItems = Array.from(document.querySelectorAll('testimonial-product-item'))
  .filter(el => !el.hasAttribute('hidden'));
  
  return {
    name: link.dataset.productTitle || null,
    id: link.dataset.productId || null,
    format: link.dataset.productType || null,
    price: link.dataset.productPrice || null,
    sku: link.dataset.productSku || null,
    upc: link.dataset.productBarcode || null,
    category: link.dataset.productCategory || null,
    outboundUrl: link.href,
    location: "Shop Review Banner"
  };
}
}

// Product tile in review banner HMPG-06 HMPG-07 --end

// Plan Your Trip ElementViewed HMPG-10,11,12,13 --start

{
const tabs = document.querySelectorAll('.tabs-nav__item-list button');
const observedTabs = new Set();

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    const tab = entry.target;
    const tabText = tab.textContent.trim();
    const tabPosition = tab.getAttribute('data-item-index');

    if (entry.isIntersecting && !observedTabs.has(tab)) {
      tagular("ElementViewed", {
        // actionOutcome: "SELECT",
        // outboundUrl: null,
        webElement: {
          elementType: "Tab",
          htmlId: tab.id || null,
          location: "Plan Your Trip Banner",
          name: capitalizeWords(tabText),
          position: tabPosition,
          text: tabText.toUpperCase(),
          variant: null
        }
      });

      if (tab.getAttribute('aria-expanded') === 'true' && tab.dataset.tabViewed != "true") {
        let buttonText = document.querySelector('.arrow_and_button a').textContent.trim();
        tagular("ElementViewed", {
          // actionOutcome: "INTERNALLINK",
          // outboundUrl: window.location.href,
          webElement: {
            elementType: "Button",
            htmlId: null,
            location: `Plan Your Trip Banner - ${capitalizeWords(tabText)}`,
            name: "View All Guides Button",
            position: null,
            text: buttonText,
            variant: null
          }
        });
        tab.setAttribute('data-tab-viewed','true')
      }
      observedTabs.add(tab);
    }
  });
}, { threshold: 0.5 });

// Observe each tab
tabs.forEach(tab => observer.observe(tab));

function capitalizeWords(str) {
  return str.replace(/\b\w/g, char => char.toUpperCase());
}
}

// Plan Your Trip ElementViewed HMPG-10,11,12,13 --end

// Plan Your Trip ElementClicked HMPG-13 --start
{
document.querySelectorAll('.arrow_and_button .button--link').forEach(button => {
  button.addEventListener('click', function (e) {
    // e.preventDefault();
    const tab = document.querySelector('.tabs-nav__item[aria-expanded="true"]');
    const tabName = tab
      ? tab.textContent.trim().split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
      : 'Unknown';

    const productText = e.currentTarget.textContent.trim();

    tagular("ElementClicked", {
      actionOutcome: "INTERNALLINK",
      outboundUrl: this.href,
      webElement: {
        elementType: "Button",
        htmlId: this.id || null,
        location: `Plan Your Trip Banner - ${tabName}`,
        name: "View All Guides Button",
        position: null,
        text: productText,
        variant: null
      }
    });
  });
});
}

// Plan Your Trip ElementClicked HMPG-13 --end


// User clicks on a product tile HMPG-14,CART-04,CART-13 ProductViewed --start

{
const viewCount = new Map();
const clickCount = new Map();
const observedProducts = new Set();
// Track last time we fired view for each product
const lastViewTime = new Map();
const viewCooldown = 2000; // 2 seconds between re-fires for the same product

const productObserver = new IntersectionObserver(handleIntersections, { threshold: 0.5 });

function handleIntersections(entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const product = entry.target;
      const productId = product.dataset.product;
      if (!productId) return;

      const now = Date.now();
      const lastTime = lastViewTime.get(productId) || 0;
      if (now - lastTime < viewCooldown) return; // prevent spamming while in view
      lastViewTime.set(productId, now);

      // Count view
      viewCount.set(productId, (viewCount.get(productId) || 0) + 1);

      // Fire view tracking logic (tagular call)
      const titleEl = product.querySelector('.product-item-meta__title');
      const title = titleEl ? titleEl.textContent.trim() : null;
      const variantEl = product.querySelector('.combo-box__option-item[aria-selected="true"]');
      const variant = variantEl ? variantEl.dataset.title : null;
      const priceEle = product.querySelector('.price');
      const priceMatch = priceEle.textContent.match(/[\d,]+\.\d{2}/);
      const price = priceMatch ? priceMatch[0] : "0.00";
      const productPrice = parseFloat(price.replace(/,/g, "")) || null;
      const tabName = getActiveTabName(product);
      let position = parseInt(product.getAttribute('data-product-index'));
      let sku = product.getAttribute('data-sku') || null;
      let upc = product.getAttribute('data-code') || null;

      if (!sku || !upc) {
        let tagularJson = product.querySelector('script[tagular-data]');
        const data = JSON.parse(tagularJson.textContent);
        const variantId = variantEl?.getAttribute('value');
        if (data?.[variantId]) {
          sku = data[variantId].sku || null;
          upc = data[variantId].barcode || null;
        } else {
          sku = data[Object.keys(data)[0]].sku || null;
          upc = data[Object.keys(data)[0]].barcode || null;
        }
      }

      let productLocation = null;
      const homepageContainer = product.closest('.js-track-homepage');
      const cartElement = product.closest('.shopify-section--cart-recommendations');
      const miniCartElement = product.closest('.mini-cart__recommendations-list');
      if (homepageContainer) {
        let locationName = homepageContainer.querySelector(".text-container h3")?.textContent.trim() || "Product Carousel"; 
        productLocation = locationName;
        if (product.closest(".js-collection-gift-guide")) {
            const locationData = product.closest(".js-collection-gift-guide").dataset.location;
            productLocation = locationData || 'PLP Results';
          }
      } else if (cartElement) {
        productLocation = 'Cart-Recs';
      } else if (miniCartElement) {
        productLocation = 'Cart Siderail - Recs';
      }

      if (homepageContainer || cartElement || miniCartElement) {
        tagular('ProductViewed', {
          product: {
            brand: 'SHOP',
            category: tabName,
            coupon: null,
            formatSubtype: null,
            formatType: variant,
            location: productLocation,
            name: title,
            pageId: null,
            position: position, // ensure it's a string if API needs it
            price: productPrice,
            productId: null,
            quantity: 1,
            sku: sku,
            subscription: { frequency: null },
            text: null,
            upc: upc,
            variant: variant,
            positionEngine: null
          }
        });
      }
    }
  });
}

function getActiveTabName(product) {
  const tabContainer = product.closest('.container') || null;
  const tab = tabContainer?tabContainer.querySelector('.tabs-nav__item[aria-expanded="true"]'):null;
  return tab ? tab.textContent.trim() : null;
}

function setupProductTracking() {
  const productTiles = document.querySelectorAll('.product-item');
  productTiles.forEach(product => {
    const productPage = product.closest('.js-product-page')
    if(productPage) return;
    const productId = product.dataset.product;
    if (!productId) return;

    // Observe for product view
    productObserver.observe(product);

    // Bind click tracking
    const links = product.querySelectorAll('a[href]');
    links.forEach(link => {
      if (link.dataset.tracked) return; // Avoid rebinding
      link.dataset.tracked = "true";

      link.addEventListener('click', (e) => {
        // e.preventDefault();
        clickCount.set(productId, (clickCount.get(productId) || 0) + 1);

        // Fire click tracking logic (tagular call)
        const titleEl = product.querySelector('.product-item-meta__title');
        const title = titleEl ? titleEl.textContent.trim() : null;
        const variantEl = product.querySelector('.combo-box__option-item[aria-selected="true"]');
        const variant = variantEl ? variantEl.dataset.title : null;
        const priceEle = product.querySelector('.price');
        const priceMatch = priceEle.textContent.match(/[\d,]+\.\d{2}/);
        const price = priceMatch ? priceMatch[0] : "0.00";
        const productPrice = parseFloat(price.replace(/,/g, "")) || null;
        const tabName = getActiveTabName(product);
        let position = parseInt(product.getAttribute('data-product-index'));
        let sku = null;
        let upc = null;
        sku = product.getAttribute('data-sku');
        upc = product.getAttribute('data-code');

      if (!sku || !upc) {
        let tagularJson = product.querySelector('script[tagular-data]');
        const data = JSON.parse(tagularJson.textContent);
        const variantId = variantEl?.getAttribute('value');
        if (data?.[variantId]) {
          sku = data[variantId].sku || null;
          upc = data[variantId].barcode || null;
        } else {
          sku = data[Object.keys(data)[0]].sku || null;
          upc = data[Object.keys(data)[0]].barcode || null 
        }
      }

        let location = null;
        const hompageElement = link.closest('.js-track-homepage');
        const plpElement = link.closest('.best-seller-scroll');
        const exploreElement = link.closest('.product-facet__product-list');
        const cartElement = link.closest('.shopify-section--cart-recommendations');
        const miniCartElement = link.closest('.mini-cart__recommendations-list');

        if (hompageElement) {
        let locationName = hompageElement.querySelector(".text-container h3")?.textContent.trim() || "Product Carousel"; 
          location = locationName;
          if (product.closest(".js-collection-gift-guide")) {
            const locationData = product.closest(".js-collection-gift-guide").dataset.location;
             productLocation = locationData || 'PLP Results';         
          }
        } else if (plpElement) {
          location = 'PLP Best Sellers Carousel';
        } else if (exploreElement) {
          location = 'PLP Results';
        } else if (cartElement) {
          location = 'Cart-Recs';
        } else if (miniCartElement) {
          location = 'Cart Siderail - Recs';
        } else {
          location = null;
        }

        if (window.location.href.includes("product")) {
           location = 'PDP - Recommended For You';
        }

        // Send ProductClicked to Tagular
        tagular('ProductClicked', {
          actionOutcome: 'INTERNALLINK',
          correlationId: null,
          viewCorrelationId: null,
          listId: null,
          outboundUrl: link.href,
          product: {
            brand: 'SHOP',
            category: tabName,
            coupon: null, 
            formatSubtype: null,
            formatType: variant,
            location: location,
            name: title,
            pageId: null,
            position: position,
            price: productPrice,
            productId: null,
            quantity: 1,
            sku: sku,
            subscription: { frequency: null },
            text: null,
            upc: upc,
            variant: variant,
            positionEngine: null
          }
        });
      });
    });
  });
}

// Initial setup
setTimeout(() => {
  setupProductTracking();
}, 1000);

// Observe DOM changes for dynamically added products
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if ([...mutation.addedNodes].some(node =>
      node.nodeType === 1 && node.matches?.('.product-item, .product-item *'))) {
      setTimeout(() => {
        setupProductTracking(); // Re-run setup on new products
      }, 1000);
      break;
    }
  }
});
observer.observe(document.body, {
  childList: true,
  subtree: true
});

}

// User clicks on a product tile HMPG-14,PLP-07,PLP-14,CART-04,CART-13 ProductClicked --end

// ShopPay button on books HMPG-17,HMPG-16,PLP-09,PLP-16,PLP-17 --start
{
  setTimeout(() => {
    let shopButton = document.querySelectorAll('shopify-accelerated-checkout');
    shopButton.forEach(button => {
      button.addEventListener('click', (e) => {
        const productPage = e.target.closest('.product_form_group');
        if(productPage) return;
        const product = e.target.closest('.product-item');
        if(product){
          const productName = product.querySelector('.product-item-meta__title')?.innerText.trim() || null;
          const position = parseInt(product.getAttribute('data-product-index'));
          const variantEl = product.querySelector('.combo-box__option-item[aria-selected="true"]');
          const variant = variantEl ? variantEl.dataset.title : null;
          const priceEle = product.querySelector('.price');
          const priceMatch = priceEle.textContent.match(/[\d,]+\.\d{2}/);
          const price = priceMatch ? priceMatch[0] : "0.00";
          const productPrice = parseFloat(price.replace(/,/g, "")) || null;
          const tabName = getActiveTabName(product);
          let sku = null;
          let upc = null;
          let tagularJson = product.querySelector('script[tagular-data]');
          const data = JSON.parse(tagularJson.textContent);
          const variantId = variantEl?.getAttribute('value');
          if (data?.[variantId]) {
            sku = data[variantId].sku || null;
            upc = data[variantId].barcode || null;
          } else {
            sku = data[Object.keys(data)[0]].sku || null;
            upc = data[Object.keys(data)[0]].barcode || null
          }
          let hompageButton = e.target.closest('.js-track-homepage');
          let plpButton = e.target.closest('.best-seller-scroll');
          let exploreElement = e.target.closest('.product-facet__product-list');
          const cartElement = e.target.closest('.shopify-section--cart-recommendations');
          const miniCartElement = e.target.closest('.mini-cart__recommendations-list');
          let location = null;
          if (hompageButton) {
            let tab = document.querySelector('.tabs-nav__item[aria-expanded="true"]').textContent.trim() || null;
            location = `Plan Your Trip Banner - ${tab}`;
          } else if(plpButton){
            location = 'PLP Best Sellers Carousel';
          } else if(exploreElement){
            location = 'PLP Results';
          } else if (cartElement) {
            location = 'Cart - Recs';
          } else if (miniCartElement) {
            location = 'Cart Siderail - Recs';
          } else {
            location = null;
          }
          tagular('ProductClicked', {
            actionOutcome: 'Checkout',
            correlationId: null,
            viewCorrelationId: null,
            listId: null,
            outboundUrl: null,
            product: {
              brand: 'SHOP',
              category: tabName,
              coupon: null, 
              formatSubtype: null,
              formatType: variant,
              htmlId: null,
              location: location,
              name: productName,
              pageId: null,
              position: position,
              price: productPrice,
              productId: null,
              quantity: 1,
              sku: sku,
              subscription: { frequency: null },
              text: "Buy with ShopPay",
              upc: upc,
              variant: variant,
              positionEngine: null
            }
          });
        }
      })
    })
  }, 1000);
}
// ShopPay button on books HMPG-17,HMPG-16,PLP-09,PLP-16,PLP-17,CART-08.01 --end

// HMPG-04 ElementViewed--start

{
const banner = document.querySelector('.js-gallery');
if (banner) {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        tagular('ElementViewed', {
          // actionOutcome: 'INTERNALLINK',
          // outboundUrl: '',
          webElement: {
            elementType: 'Tile',
            htmlId: null,
            location: 'Shop Best Collections',
            name: null,
            position: null,
            text: null,
            variant: null
          }
        });
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  observer.observe(banner);
}
}
// HMPG-04 ElementViewed--end